import React from 'react';
import { ImagePanel } from './view/imagePanel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'ImagePanel', 
  itemElt: (item, cmsOption) => <ImagePanel item={item} cmsOption={cmsOption} />
}